import React from 'react';
import { FcApproval } from 'react-icons/fc';
import styled from 'styled-components';
import { DarkThemeColor ,ThemeBorderColor} from '../../utils';
import Card from './Card';

function PointCard(props) { 
    return (
        <Card clickCardHandler={props.clickCardHandler} title="امتیازات کسب شده" icon={FcApproval}>
            <Score>{props.SumPoint}</Score>
        </Card>
    );
}
const Score = styled.span`
    color: ${DarkThemeColor};
    width: 120px;
    margin:10px 20px;
    display: inline-block;
    border-radius: 1rem;
    padding: 0.7rem;
    border: 2px solid ${ThemeBorderColor};
    font-size: x-large;
`;
export default PointCard;